<template>
  <div class="flex-column">
    <md-switch v-model="value">
      {{ tx(model) }}
    </md-switch>
  </div>
</template>

<script>
import inputComponentMixin from "ireal-vue/mixins/input-component-mixin.js";

export default {
  name: "switch-button-component",
  mixins: [inputComponentMixin],
  data() {
    return {};
  },

  async mounted() {
    this.checked = this.attributes.default;
    this.attributes.default == "true"
      ? (this.value = true)
      : (this.value = false);
  },
  methods: {
    click() {
      this.value = !this.value;
      this.value ? this.doActionTrue() : this.doActionFalse();
    },
    doActionTrue(payload) {
      this[this.attributes["action-true"]](payload);
    },
    doActionFalse(payload) {
      this[this.attributes["action-false"]](payload);
    },
  },
  computed: {
    label() {
      return `${this.attributes.model}_${this.value ? "true" : "false"}`;
    },
    button_clazz() {
      return `btn btn-warning w-100 text-uppercase`;
    },
    img() {
      return this.value ? this.attributes.img_false : this.attributes.img;
    },
    help() {
      var model_help = `${this.attributes.model}_help`;
      return this.attributes.model !== undefined ? this.tx(model_help) : "";
    },
  },
};
</script>
<style scoped></style>
